<template>
  <div class="text-counter text--caption" :class="{ 'text-error': textIsTooLong }">
    <span>{{currentLength}}</span>
    <template v-if="maxLength">
      <span>/</span>
      <span>{{maxLength}}</span>
    </template>
  </div>
</template>

<script>
/**
 * Default Text counter
 * @displayName TextCounter
 */
/**
 * Display a text counter. Used under richtext textarea to match the vuetify input counter
 */
export default {
  name: 'TextCounter',
  props: {
    /**
     * The text length
     */
    currentLength: {
      type: Number,
      required: true,
    },
    /**
     * The text max length
     */
    maxLength: {
      type: Number,
    },
  },
  computed: {
    textIsTooLong () {
      return this.currentLength > this.maxLength
    },
  },
}
</script>
<style scoped>
  .text-counter {
    display: flex;
    color: rgb(var(--v-theme-grey-lighten-1));
    column-gap: 1px;
  }
</style>